import { getUserToken } from "../auth/sso-auth";
import { reportLoaders } from "../../Reports/report-loader";
import { postJsonWithBearer } from "../../shared/utils/helper-methods";
import {postMultipartWithBearerFileAPI } from "./file-submission"
import { Config } from "../../services/config";

export async function reportDataCall(clientId: string, clientDate: string, dataType: string): Promise<void> {

    let dataOutput = null;
    const APIURL = Config.API_ENDPOINTS.GET_CLIENT_DATA;

    try {
        const userToken: string = await getUserToken();
        const payload = {
        clientId: clientId,
        clientDate: clientDate,
        dataType: dataType,
        };

        const result = await postJsonWithBearer(APIURL, userToken, payload);
        dataOutput = result.data;
        //console.log('API result:', result);
    } catch (err) {
        console.error('Error fetching client data:', err);
        throw new Error(`Failed to fetch client data: ${err instanceof Error ? err.message : 'Unknown error'}`);
    }

    // Report specific process loading
    // Default to report 4 (combined)
    const reportType = 4;
    const loader = reportLoaders[reportType];
    if (!loader) {
        throw new Error(`Unknown reportType: ${reportType}`);
    }

    const { reportLogic } = await loader();

    // Run the report-specific logic and return the result
    try {
        const result = await reportLogic(dataOutput);
    } catch (err) {
        console.error('Error executing report logic:', err);
        throw new Error(`Failed to execute report: ${err instanceof Error ? err.message : 'Unknown error'}`);
    }

}


type ApiResponse = {
  status: number;
  message: string;
  data: { [clientName: string]: { carrierName: string; dbaName: string; recordType: string; hasMapping: boolean } };
};

export async function clientListDataCall(): Promise<ApiResponse> {

    const APIURL = Config.API_ENDPOINTS.GET_CLIENT_LIST;

    try {
        const userToken: string = await getUserToken();
        const payload = {
        requestedBy: 'Excel Add-in',
        timestamp: new Date().toISOString(),
        filters: { includeInactive: false }
        };

        const result = await postJsonWithBearer(APIURL, userToken, payload);

        return JSON.parse(result);
        //console.log('API result:', result);
    } catch (err) {
        console.error(err);
    }
}

export async function clientMonthsDataCall(clientId : string): Promise<ApiResponse> {

    const APIURL = Config.API_ENDPOINTS.GET_CLIENT_MONTHS;

    try {
        const userToken: string = await getUserToken();
        const payload = {
          clientId: clientId
        };

        const result = await postJsonWithBearer(APIURL, userToken, payload);

        return  result;
        //console.log('API result:', result);
    } catch (err) {
        console.error(err);
    }
}

export async function clientMappingSubmitCall(clientId : string, carrierPlan : string, mbPlan : string, carrierSelectMapping?: string, id?: string, action?: string): Promise<ApiResponse> {

    const APIURL = Config.API_ENDPOINTS.SUBMIT_CLIENT_MAPPING;

    try {
        const userToken: string = await getUserToken();
        const payload: any = {
          ClientId: clientId,
          CarrierMapping: carrierPlan,
          MBMapping: mbPlan
        };

        // Add optional parameters if provided
        if (carrierSelectMapping) {
          payload.CarrierSelectMapping = carrierSelectMapping;
        }
        if (id) {
          payload.Id = id;
        }
        if (action) {
          payload.Action = action;
        }

        const result = await postJsonWithBearer(APIURL, userToken, payload);

        return  result;
        //console.log('API result:', result);
    } catch (err) {
        console.error(err);
    }
}

export async function clientMappingGetCall(search : string): Promise<ApiResponse> {

    const APIURL = Config.API_ENDPOINTS.GET_CLIENT_MAPPING;

    try {
        const userToken: string = await getUserToken();
        const payload = {
          Search: search
        };

        const result = await postJsonWithBearer(APIURL, userToken, payload);

        return  result;
        //console.log('API result:', result);
    } catch (err) {
        console.error(err);
    }
}

export async function getErrorDataCall(): Promise<any> {
    const APIURL = Config.API_ENDPOINTS.GET_ERROR_DATA;

    try {
        const userToken: string = await getUserToken();
        const payload = {}; // Empty payload as requested

        const result = await postJsonWithBearer(APIURL, userToken, payload);
        
        console.log('Error data API result:', result);
        return result;
    } catch (err) {
        console.error('Error calling get error data:', err);
        throw err;
    }
}

export async function reportDataCallFilesUpload(
  dataType: number,
  uploadCarrier: string,
  uploadClient: string,
  files: File[],
  isIncurred?: boolean
): Promise<void> {
  const statusEl = document.getElementById("uploadStatus");
  const btn = document.getElementById("uploadBtn") as HTMLButtonElement | null;

  const setStatus = (msg: string) => { if (statusEl) statusEl.textContent = msg; };

  if (!files || files.length === 0) {
    setStatus("Please select at least one file.");
    return;
  }

  const APIURL = Config.API_ENDPOINTS.HANDLE_SUBMISSION;

  const payload = {
    dataType: dataType,
    uploadCarrier: uploadCarrier,
    uploadClient: uploadClient,
    incurred: isIncurred || false,
  };
  console.log(payload);
  try {
    if (btn) btn.disabled = true;
    setStatus("Uploading…");

    const userToken = await getUserToken();

    const res = await postMultipartWithBearerFileAPI({
      bearerToken: userToken,
      url: APIURL,
      files, // <-- File[] here
      jsonPartName: "metadata",  // coordinate with API
      jsonPayload: payload,
      filePartName: "files",     // coordinate with API
      timeoutMs: 2 * 60 * 1000,  // 2 minutes
    });
    if (!res.ok) {
      switch (res.status) {
        case 0:
          setStatus(res.text || "Network error or timeout.");
          break;
        case 401:
          setStatus("Unauthorized. Your session may have expired—please sign in again.");
          break;
        case 403:
          setStatus("Forbidden. Your account doesn't have permission to upload.");
          break;
        case 413:
          setStatus("Upload too large (413). Try fewer/smaller files or compress them.");
          break;
        default:
          setStatus(`Upload failed (${res.status}). ${res.text ?? ""}`);
          break;
      }
      console.error("Upload failed:", res);
      return;
    }

    // Success
    if (res.data) {
      setStatus("Upload complete.");
      console.log("API result (JSON):", res.data);
      
      // Dispatch event to clear file queue after successful upload
      const clearEvent = new CustomEvent('clearFileQueue', { bubbles: true });
      document.dispatchEvent(clearEvent);
    } else {
      setStatus("Upload complete (non-JSON response).");
      console.log("API result (text):", res.text);
      
      // Dispatch event to clear file queue after successful upload
      const clearEvent = new CustomEvent('clearFileQueue', { bubbles: true });
      document.dispatchEvent(clearEvent);
    }
  } catch (err) {
    console.error("Unexpected error:", err);
    setStatus("Unexpected error during upload.");
  } finally {
    if (btn) btn.disabled = false;
  }
}


